module.exports = __webpack_public_path__ + "static/media/fotc.d84c0854.md";